import React from 'react'
import { Link } from 'react-router-dom'

import './press.css'
import Article from '../../../article/Article'
import Fanzine from '../../../fanzine/Fanzine'
import articlesData from '../../../../mocks/articles.json'
import fanzinesData from '../../../../mocks/fanzines.json'
import SubHeading from '../../../subHeading/SubHeading'
import { getFeaturedArticles } from '../../../../utilities/articles'

const Press = () => {
  const featuredArticles = getFeaturedArticles(articlesData.Articles)

  return (
    <section className='press section__padding' id='press'>
      <div className='press__heading'>
        <SubHeading title='Divulgación' color={true} />
        <p className='normal-text'>
          Coordinación y participación en charlas, formaciones, jornadas o seminarios.
        </p>
        <p className='normal-text'>
          Creación de material divulgativo sobre la menstruación, el ciclo menstrual y
          el climaterio.
        </p>
      </div>

      <div className='press__articles'>
        <h4>Artículos</h4>
        <div className='press__articles-container'>
          {featuredArticles.map((article) => (
            <Article
              key={article.id}
              imgUrl={article.imgUrl}
              title={article.title}
              url={article.url}
              date={article.date}
            />
          ))}
        </div>
        <div className='press__articles-cta'>
          <Link to='/articulos' className='main__button main__button--alt press__articles-link'>
            Ver todos los artículos
          </Link>
        </div>
      </div>

      <div className='press__fanzines'>
        <h4>Fanzines</h4>
        <div className='press__fanzines-container'>
          {fanzinesData.Fanzines.map((fanzine) => (
            <Fanzine key={fanzine.id} href={fanzine.url} imgUrl={fanzine.imgUrl} />
          ))}
        </div>
      </div>
    </section>
  )
}

export default Press
